<template>
  <div id="bookingServiceList">
    <v-list-item @click="onItemClick($event)">
      <v-flex sm1>
        <v-scroll-x-transition>
          <v-icon v-if="checked" color="success" large>mdi-check</v-icon>
        </v-scroll-x-transition>
      </v-flex>
      <v-flex sm8>
        <v-list-item-content>
          <v-list-item-title>
            <span class="title">{{ service.serviceName }}</span>
            (Price From: {{ service.priceFrom | priceLabeler }}
            {{ service.priceFromCurrencyCode }})
          </v-list-item-title>
        </v-list-item-content>
      </v-flex>

      <v-flex sm1>
        <v-text-field
          label="Adults"
          v-model.number="item.adults"
          type="number"
          min="0"
          :max="itinerary.adults"
          @keypress="isNumberBigger($event, item.adults, itinerary.adults)"
          class="pr-2 pt-4"
        ></v-text-field>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          label="Children"
          v-model.number="item.children"
          type="number"
          min="0"
          :max="itinerary.children"
          @keypress="isNumberBigger($event, item.children, itinerary.children)"
          class="pr-2 pt-4"
        ></v-text-field>
      </v-flex>
      <v-flex sm1>
        <v-text-field
          label="Infants"
          v-model.number="item.infants"
          type="number"
          min="0"
          :max="itinerary.infants"
          @keypress="isNumberBigger($event, item.infants, itinerary.infants)"
          class="pt-4"
        ></v-text-field>
      </v-flex>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "ServiceItem",

  props: {
    service: {
      type: Object,
      default: () => ({}),
    },
    startDate: {
      type: String,
      default: "",
    },
    endDate: {
      type: String,
      default: "",
    },
    itinerary: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      debug: false,
      item: {
        serviceId: this.service.serviceId,
        adults: 0,
        children: 0,
        infants: 0,
        startDate: this.startDate,
        endDate: this.endDate,
        qty: 1,
      },
    };
  },

  computed: {
    checked() {
      return (
        this.item.adults != 0 ||
        this.item.children != 0 ||
        this.item.infants != 0
      );
    },
  },

  watch: {
    startDate(data) {
      this.item.startDate = data;
    },

    endDate(data) {
      this.item.endDate = data;
    },

    item: {
      handler(data) {
        this.$emit("onChange", data);
      },

      deep: true,
    },
  },
  methods: {
    onItemClick($event, currentInput) {
      if ($event.target.tagName.toString() != "INPUT") {
        for (let field of ["adults", "children", "infants"]) {
          this.item[field] = new Number(this.itinerary[field]);
        }
      }
    },
    isNumberBigger(e, currentValue, maxValue) {
      let currentChar = parseInt(String.fromCharCode(e.keyCode), 10);
      if (!isNaN(currentChar)) {
        let nextValue = "" + currentValue + currentChar;
        if (parseInt(nextValue, 10) > maxValue) {
          e.preventDefault();
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/booking/SupplierBookingServiceItem.vue